// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f32891d9","769":"1687ab9b"}[chunkId] + ".chunk.js";
};